// Ties the in-memory page cache (dataCache.js) to who is signed in.
import { clearAll, setCacheUser } from './dataCache';

/** Tell the cache who is signed in now (a different user, or nobody, wipes it). */
export function syncCacheUser(session) {
  setCacheUser(session && session.user ? session.user.id : null);
}

/** Every sign-in / sign-out event: a sign-out wipes everything, then the user is synced. */
export function onAuthEvent(event, session) {
  if (event === 'SIGNED_OUT') clearAll();
  syncCacheUser(session);
}
